import { Checkbox } from "../../shared/uikit/Form/Checkbox";

export const SnippetCheckboxCell = ({
  row,
  handleCheckboxChange,
  selectedIds,
}: {
  row: any;
  handleCheckboxChange: (id: number) => void;
  selectedIds: number[];
}) => (
  <Checkbox
    checked={selectedIds.includes(row.original?.id)}
    onChange={() => handleCheckboxChange(row.original?.id)}
    name={`snippet-${row.original?.id}`}
    isFormItem={false}
    onClick={e => e.stopPropagation()}
  />
);
